// extracted by mini-css-extract-plugin
module.exports = {"edit-series-layout-background":"SeriesBasicInfo_edit-series-layout-background__3Niyv"};